import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

import { Link } from "react-router-dom";

// img
import u1 from "../../../Assets/images/user.png";
import { useDispatch, useSelector } from "react-redux";
import { getDisputes } from "../../../store/dispute/actions";
import Table from "../../../components/Common/Table";
import moment from "moment";
import { toast } from "react-toastify";
import { UPDATE_STATUS_DISPUTE } from "../../../services/ApiCalls";
import CustomPagination from "../../../components/Common/CustomPagination";
import Search from "../../../components/Common/Search";
import StatusFilter from "../../../components/Common/StatusFilter";
import { openCloseFilterOptionArr } from "../../../utilities/const";
import PaginationFilter from "../../../components/Common/PaginationFilter";

const DisputeManagement = () => {
  const data = [
    {
      BookingID: "225865#VD",
      reason:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna",
      email: "sara.cruz@example.com",
      status: "active",
      created: "Dec 7, 2019 23:26",
    },
    {
      BookingID: "225865#VD",
      reason:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna",
      email: "sara.cruz@example.com",
      status: "unactive",
      created: "Dec 7, 2019 23:26",
    },
  ];

  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    search: "",
    status: "all",
  });
  const dispatch = useDispatch();

  const disputesListData = useSelector((s) => s.dispute.disputeListData);
  const disputesListDataTotal = useSelector((s) => s.dispute.total);
  const loader = useSelector((s) => s.dispute.loading);

  useEffect(() => {
    const newBody = {
      ...body,
      page: 1,
    };
    setBody(newBody);
    if (body.search.trim() === "") dispatch(getDisputes(newBody));
  }, [body.search]);

  useEffect(() => {
    const newBody = {
      ...body,
      page: 1,
    };
    setBody(newBody);
    dispatch(getDisputes(newBody));
  }, [body.status, body.limit]);

  const searchHandler = () => {
    const newBody = {
      ...body,
      page: 1,
    };
    setBody(newBody);
    dispatch(getDisputes(newBody));
  };

  const pageChangeHandler = (page) => {
    const newBody = {
      ...body,
      page,
    };
    setBody(newBody);
    dispatch(getDisputes(newBody));
  };
  const statusChangeHandler = async (item) => {
    try {
      const res = await UPDATE_STATUS_DISPUTE({
        disputeId: item._id,
        disputeStatus: item.status === "completed" ? "open" : "completed",
      });
      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        dispatch(getDisputes(body));
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  const col = [
    {
      label: "Booking Id",
      id: "bookingId",
      classNames: "text-primary fw-sbold",
    },
    {
      label: "Name",
      id: "name",
      isComponent: true,
      component: (item) => <p className={` m-0`}>{item?.customer?.name}</p>,
    },
    {
      label: "Email",
      id: "email",
      isComponent: true,
      component: (item) => <p className={` m-0`}>{item?.customer?.email}</p>,
    },
    {
      label: "Reason",
      id: "reason",
    },
    {
      label: "Status",
      id: "Status",
      // isComponent: true,
      // component: (item) => (
      //   <Form.Check
      //     type="switch"
      //     id="custom-switch"
      //     checked={item.Status == "completed" ? true : false}
      //     onClick={() => statusChangeHandler(item)}
      //   />
      // ),
      isComponent: true,
      component: (item, key, data) => {
        return (
          <p
            className={`${
              item.disputeStatus === "close" ? "text-success" : "text-primary"
            } m-0 fw-sbold `}
          >
            {item?.disputeStatus.charAt(0).toUpperCase() +
              item?.disputeStatus.slice(1)}
          </p>
        );
      },
    },
    {
      label: "Created at",
      id: "createdAt",
      isComponent: true,
      component: (item) => (
        <p className={` m-0`}>
          {moment(item.createdAt).format("MM-DD-YYYY , HH:mm A")}
        </p>
      ),
    },
    {
      label: "View",
      id: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn">
          <Link
            to={`/dispute-management/view/${item._id}`}
            className="border-0 p-0"
            variant="transparent"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 25 17"
              fill="none"
            >
              <path
                d="M24.8389 7.9541C22.8564 5.34668 20.8301 3.35937 18.8184 2.04102C16.7578 0.693359 14.6582 0.00488281 12.5684 0C12.5586 0 12.5488 0 12.5391 0C10.4443 0 8.3252 0.683594 6.25 2.03613C4.22363 3.34961 2.17285 5.3418 0.161133 7.94922C-0.0537109 8.23242 -0.0537109 8.62305 0.161133 8.90137C2.17285 11.5137 4.22363 13.5059 6.25 14.8193C8.33008 16.1719 10.4443 16.8555 12.5391 16.8555H12.5684C14.6582 16.8506 16.7627 16.1621 18.8184 14.8145C20.8301 13.4961 22.8516 11.5088 24.8389 8.90137C25.0537 8.62305 25.0537 8.23242 24.8389 7.9541ZM12.5635 15.293C12.5537 15.293 12.5439 15.293 12.5391 15.293C9.02832 15.293 5.40527 12.9834 1.77246 8.42773C5.40527 3.87207 9.02344 1.5625 12.5391 1.5625H12.5635C16.0645 1.57227 19.6533 3.88184 23.2275 8.42773C19.6533 12.9736 16.0693 15.2832 12.5635 15.293ZM12.5 3.54492C9.80957 3.54492 7.61719 5.73731 7.61719 8.42773C7.61719 11.1182 9.80957 13.3105 12.5 13.3105C15.1904 13.3105 17.3828 11.1182 17.3828 8.42773C17.3828 5.73731 15.1904 3.54492 12.5 3.54492ZM12.5 11.748C10.6689 11.748 9.17969 10.2588 9.17969 8.42773C9.17969 6.59668 10.6689 5.10742 12.5 5.10742C14.3311 5.10742 15.8203 6.59668 15.8203 8.42773C15.8203 10.2588 14.3311 11.748 12.5 11.748Z"
                fill="#666666"
              />
            </svg>
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>
      <section className="disputeManagement py-3">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <Container>
                <Row>
                  <Col lg="12" className="my-2">
                    <div className="TableFilter gap-10 mb-3 d-flex align-itmes-center justify-content-between flex-wrap">
                      <div className="left">
                        <ul className="list-unstyled ps-0 mb-0 d-flex align-itmes-center gap-10">
                          <StatusFilter
                            body={body}
                            setBody={setBody}
                            statusFilterOptionArr={openCloseFilterOptionArr}
                          />
                          <PaginationFilter body={body} setBody={setBody} />
                          {/* <Search
                            setBody={setBody}
                            searchHandler={searchHandler}
                          /> */}
                        </ul>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <Table
                        data={disputesListData}
                        column={col}
                        loader={loader}
                      />
                      <div className="d-flex justify-content-end">
                        <CustomPagination
                          current={body.page}
                          pageSize={body.limit}
                          total={disputesListDataTotal}
                          pageChangeHandler={pageChangeHandler}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default DisputeManagement;
